import { render, staticRenderFns } from "./OrderFiles.vue?vue&type=template&id=7b6d68e6&scoped=true&"
import script from "./OrderFiles.vue?vue&type=script&lang=js&"
export * from "./OrderFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6d68e6",
  null
  
)

export default component.exports